export const initialSignupForm = {
  first: "",
  last: "",
  dateOfBirth: "",
  email: "",
  password: "",
  // #65. Starts false so registration is blocked until the user checks the
  // Terms/Privacy consent box; its presence is also what makes the shared
  // UserForm render the consent control (edit forms omit it).
  acceptedTerms: false,
};
